'use client';

import { MODALS } from '@/constants/modals';
import useModalStore from '@/stores/modals';
import { FormModalData, ModalData } from '@/types/modals';
import { getScrollbarWidth } from '@/utils/getScrollbarWidth';
import { useEffect } from 'react';

const disableScroll = () => {
  const scrollbarWidth = getScrollbarWidth();
  const hasScrollbar =
    document.documentElement.scrollHeight >
    document.documentElement.clientHeight;

  if (hasScrollbar) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  document.body.style.overflowY = 'hidden';
};

const enableScroll = () => {
  document.body.style.overflowY = 'auto';
  document.body.style.paddingRight = '';
};

const useModal = () => {
  const activeModals = useModalStore((state) => state.activeModals);
  const show = useModalStore((state) => state.openModal);
  const add = useModalStore((state) => state.addModal);
  const remove = useModalStore((state) => state.removeModal);
  const close = useModalStore((state) => state.closeModal);

  const openModal = ({
    name,
    data,
  }: {
    name: string;
    data?: FormModalData;
  }) => {
    const modalToShow = MODALS.find((m) => m.name === name);
    if (modalToShow)
      show({
        name: modalToShow.name,
        data,
      });
  };

  const addModal = (modal: ModalData) => {
    add(modal);
  };

  const removeModal = (name: string) => {
    remove(name);
  };

  const closeModal = () => {
    close();
  };

  useEffect(() => {
    if (activeModals?.length) return disableScroll();
    enableScroll();
  }, [activeModals]);

  return { openModal, addModal, removeModal, closeModal, activeModals };
};

export default useModal;
